"use strict"

exports.getDecimalAmount = function(result, config) {
  var precision = null;
  var decimals = null;
   // check special case where 2 pointers are missing -> result will be taken from only one pointer
  if (config.decimals.positions.length === 2
    && parseFloat(config.decimals.positions[0].precision) == 0.0001
    && parseFloat(config.decimals.positions[1].precision) == 0.1) {
      precision = config.decimals.positions[1].precision;
    }

  if(!precision) {
    for (var h = 0; h < config.decimals.positions.length; h++) {
      if(result.meters[h].value > -1) {
        precision = config.decimals.positions[h].precision;
        break;
      }
    }
  }
  switch(precision) {
    case 0.0001:
      decimals = 5;
      break;
    case 0.001:
      decimals = 4;
      break;
    case 0.01:
      decimals = 3;
      break;
    case 0.1:
      decimals = 2;
      break;
    default:
      decimals = 5;
      break;
  }
  return {precision: precision, decimals: decimals};
}

exports.getConfiguredDecimalAmount = function(result, config) {
  var precision = null;
  var decimals = null;
   // check special case where 2 pointers are missing -> result will be taken from only one pointer
  if (config.decimals.positions.length === 2
    && parseFloat(config.decimals.positions[0].precision) == 0.0001
    && parseFloat(config.decimals.positions[1].precision) == 0.1) {
      precision = config.decimals.positions[1].precision;
    } else {
      precision = config.decimals.positions[0].precision;
    }

  switch(precision) {
    case 0.0001:
      decimals = 5;
      break;
    case 0.001:
      decimals = 4;
      break;
    case 0.01:
      decimals = 3;
      break;
    case 0.1:
      decimals = 2;
      break;
    default:
      decimals = 5;
      break;
  }
  return {precision: precision, decimals: decimals};
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/utils.js
// module id = 443
// module chunks = 0